import { createSelector } from 'reselect';

export const getIsEmptyBifurcation = createSelector(
  state => state.admin_details.bifurcation_data,
  bifurcation => bifurcation.filters && bifurcation.filters.length === 0
)



// WEBPACK FOOTER //
// ./src/data/redux/admin_details/selectors.js